/** Inject a script tag once by id; resolves when loaded (or immediately if already present). */
export function loadScriptOnce(options: {
  id: string;
  src: string;
  attrs?: Record<string, string>;
}): Promise<void> {
  const existing = document.getElementById(options.id);
  if (existing) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = options.id;
    script.async = true;
    script.src = options.src;
    if (options.attrs) {
      for (const [name, value] of Object.entries(options.attrs)) {
        script.setAttribute(name, value);
      }
    }
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load chat script: ${options.src}`));
    const first = document.getElementsByTagName('script')[0];
    if (first?.parentNode) {
      first.parentNode.insertBefore(script, first);
    } else {
      document.head.appendChild(script);
    }
  });
}
